import store from "../store";

function getCookie(cname: string) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let c of ca) {
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function getAuthHeaders() {
  const localUser = localStorage.getItem("covid-user");
  if (localUser) {
    return {
      Authorization: "Token " + localUser,
      IsEmbedded: store?.getState()?.session?.data?.isEmbeddedSession || false
    };
  } else {
    return {
      Authorization: "",
      IsEmbedded: store?.getState()?.session?.data?.isEmbeddedSession || false
    };
  }
}

export function getCsrfHeaders(): any {
  const reachapiCookie = getCookie("reachcsrftoken");
  if (reachapiCookie) {
    return { "X-CSRFToken": reachapiCookie };
  }
  //TODO: Remove this in follow up release.
  return {
    "X-CSRFToken": getCookie("csrftoken")
  };
}
